/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { reducerLogger } from "../../../../utility/reducerLogger";

export const actions = {
	SUCCESS_CONTACT_HISTORY: "SUCCESS_CONTACT_HISTORY",
	LOADING_CONTACT_HISTORY: "LOADING_CONTACT_HISTORY",
	FAILED_CONTACT_HISTORY: "FAILED_CONTACT_HISTORY",
	SUCCESS_SENTIMENT_RESULTS: "SUCCESS_SENTIMENT_RESULTS",
	LOADING_SENTIMENT_RESULTS: "LOADING_SENTIMENT_RESULTS",
	FAILED_SENTIMENT_RESULTS: "FAILED_SENTIMENT_RESULTS",
	REMOVE_CONTACT_DATA: "REMOVE_CONTACT_DATA",
	SET_CONTACT_SMS_MESSAGE_FORM: "SET_CONTACT_SMS_MESSAGE_FORM",
};

export const initialState = {};

export const reducer = reducerLogger((state, action) => {
	let newState = { ...state };
	let contact = newState[action.contactId];
	switch (action.type) {
		case actions.SET_CONTACT_SMS_MESSAGE_FORM:
			contact = {
				...contact,
				smsMessageFormState: { ...action.smsMessageForm },
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.SUCCESS_CONTACT_HISTORY:
			contact = {
				...contact,
				history: { ...contact?.history, loading: false, err: "", history: action.history },
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.LOADING_CONTACT_HISTORY:
			contact = {
				...contact,
				history: { ...contact?.history, initialLoad: true, loading: true, err: "", history: [] },
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.FAILED_CONTACT_HISTORY:
			contact = { ...contact, history: { ...contact?.history, loading: false, err: action.error, history: [] } };
			newState[action.contactId] = contact;
			return newState;
		case actions.INITIAL_FETCH_SENTIMENT_RESULTS:
			contact = {
				...contact,
				sentimentResults: {
					...contact?.sentimentResults,
					initialLoad: true,
					loading: false,
					err: "",
					sentimentResults: [],
				},
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.SUCCESS_SENTIMENT_RESULTS:
			contact = {
				...contact,
				sentimentResults: {
					...contact?.sentimentResults,
					loading: false,
					err: "",
					sentimentResults: action.sentimentResults,
				},
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.LOADING_SENTIMENT_RESULTS:
			contact = {
				...contact,
				sentimentResults: {
					...contact?.sentimentResults,
					initialLoad: true,
					loading: true,
					err: "",
					sentimentResults: [],
				},
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.FAILED_SENTIMENT_RESULTS:
			contact = {
				...contact,
				sentimentResults: { ...contact?.sentimentResults, loading: false, err: action.error, sentimentResults: [] },
			};
			newState[action.contactId] = contact;
			return newState;
		case actions.REMOVE_CONTACT_DATA:
			delete newState[action.contactId];
			return newState;
		default:
			return newState;
	}
});
